import { isValidPrice } from '@domain-group/javascript-utils'

export type ProviderPackageModel = {
  hidden: boolean,
  id: number,
  cache_key: number,
  price: string,
  product_code: string,
  provider_id: number,
  provider_price_list_ids?: [],
  title: string,
}

export type ProviderPackageRequestOptions = {
  include_provider_package_agencies_count: boolean,
  include_provider_package_provider: boolean,
}

const state = {
  id: null,
  price: '',
  product_code: '',
  provider_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'price', validation: isValidPrice, invalidMessage: 'Invalid Price Format' },
  { key: 'provider_id' },
  { key: 'title' },
]

export default state
